<template>
   <p id="project-id" class="text-left text-bold">
      <span>Your Project Id is: </span>{{ projectStore.projectId }}
   </p>
   <RewardInstructions />
   <p>
      It may take up to 24 hours for data to arrive in your project. After
      you've set up a reward, press the button below to continue.
   </p>
</template>

<script lang="ts" setup>
import { useProjectStore } from "@/stores/projectStore"
import RewardInstructions from "./RewardInstructions.vue"
const projectStore = useProjectStore()
</script>
